// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-searchbar {
  padding-inline: 5px;
  color: #92949C;
  background-color: white;
  position: fixed;
  z-index: 10;
}

.spinner-background {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-card {
  margin: 20px 10px;
}
ion-card:first-child {
  margin: 10px 10px 20px;
}
ion-card .wrapper {
  width: 100%;
}
ion-card ion-item {
  --inner-padding-end: 0;
}
ion-card ion-card-header {
  padding: 5px 10px 0 0px;
}
ion-card ion-card-header ion-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  justify-content: center;
}
ion-card ion-card-header ion-card-title ion-avatar {
  margin: 0 auto;
}
ion-card ion-card-header ion-card-title ion-avatar img {
  background-size: cover;
  border-radius: 15px;
  height: 45px;
  width: 45px;
}
ion-card ion-card-header ion-card-title .resource-type-icon {
  font-size: 40px;
}
ion-card ion-card-header ion-card-title ion-label {
  font-size: 20px;
  flex-grow: 3;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card ion-card-header ion-card-title ion-label .displayName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card ion-card-header ion-card-title ion-label .emailAddress {
  color: #6e6e6e;
  font-size: 12px;
  margin: 2px;
  font-weight: 500;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card ion-card-header ion-card-title .plus-icon {
  cursor: pointer;
}
ion-card ion-card-header ion-card-subtitle {
  font-size: 11px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
ion-card ion-card-header ion-card-subtitle .location-icon {
  margin-right: 2.5px;
}
ion-card ion-card-content {
  display: flex;
  padding: 5px 0 8px 0;
}
ion-card ion-card-content ion-chip {
  padding-inline: 10px;
  font-size: 12px;
}
ion-card ion-card-content ion-chip ion-icon {
  margin-right: 3.5px;
}
ion-card ion-card-content ion-chip.dumb {
  pointer-events: none;
}
ion-card ion-item-options ion-item-option div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  font-size: 14px;
}
ion-card ion-item-options ion-item-option div ion-icon {
  font-size: 30px;
}

.no-places-container {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  text-align: center;
  padding: 0 20px;
}

ion-popover.display-name {
  --width: 275px;
}
ion-popover.display-name ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label {
  margin: 5px 10px;
}
ion-popover.display-name ion-label .displayName,
ion-popover.display-name ion-label .address,
ion-popover.display-name ion-label .emailAddress {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 7px 0;
  word-break: break-word;
}
ion-popover.display-name ion-label .displayName div,
ion-popover.display-name ion-label .address div,
ion-popover.display-name ion-label .emailAddress div {
  display: flex;
}
ion-popover.display-name ion-label .address {
  font-size: 12px !important;
}
ion-popover.display-name ion-label .address ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label .displayName {
  font-size: 15px;
}
ion-popover.display-name ion-label .emailAddress ion-icon {
  color: #6e6e6e;
}
ion-popover.display-name ion-label .emailAddress small {
  color: #6e6e6e;
  font-size: 12px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/add-favorite-places/add-favorite-places.component.scss"],"names":[],"mappings":"AAoEA;EACE,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAnEF;;AA2FA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxFF;;AA2FA;EAOE,iBAAA;AA9FF;AAwFE;EACE,sBAAA;AAtFJ;AAwFE;EACE,WAAA;AAtFJ;AAyFE;EACE,sBAAA;AAvFJ;AAyFE;EACE,uBAAA;AAvFJ;AAwFI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;UAAA,0BAAA;EACA,uBAAA;AAtFN;AAuFM;EACE,cAAA;AArFR;AAsFQ;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AApFV;AAuFM;EACE,eAAA;AArFR;AAuFM;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EAEA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAtFR;AAuFQ;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AArFV;AAuFQ;EAEE,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAtFV;AAyFM;EACE,eAAA;AAvFR;AA0FI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAxFN;AAyFM;EACE,mBAAA;AAvFR;AA2FE;EACE,aAAA;EACA,oBAAA;AAzFJ;AA0FI;EACE,oBAAA;EACA,eAAA;AAxFN;AAyFM;EACE,mBAAA;AAvFR;AAyFM;EACE,oBAAA;AAvFR;AA6FM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA3FR;AA4FQ;EACE,eAAA;AA1FV;;AAiGA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AA9FF;;AAkGA;EACE,cAAA;AA/FF;AAgGE;EACE,eAAA;AA9FJ;AAgGE;EACE,gBAAA;AA9FJ;AA+FI;;;EAGE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;AA7FN;AA8FM;;;EACE,aAAA;AA1FR;AA6FI;EACE,0BAAA;AA3FN;AA6FM;EACE,eAAA;AA3FR;AA8FI;EACE,eAAA;AA5FN;AA+FM;EACE,cAAA;AA7FR;AA+FM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA7FR","sourcesContent":["// ion-icon {\n//     font-size: 45px;\n// }\n// .row-padding{\n//   padding-left: 2px;\n// }\n\n// .icon-capacity{\n//   font-size: 14px;\n// }\n\n// ion-list{\n//   padding-bottom: 0;\n// }\n\n// .space-displayName {\n//   overflow: hidden;\n//   display: -webkit-box;\n//   -webkit-line-clamp: 2;\n//   -webkit-box-orient: vertical;\n//   white-space: pre-wrap;\n//   margin-bottom: 10px;\n// }\n\n// .margin-right {\n//   margin-right: 16px;\n// }\n\n// ion-select {\n//   width: 100%;\n//   padding-left: 15px;\n//   padding-right: 15px;\n// }\n\n// ion-toolbar {\n//   --padding-top: 0;\n//   --padding-bottom: 0;\n//   --padding-right: 15px;\n// }\n\n// ion-thumbnail {\n//   margin-right: 16px;\n// }\n\n// ion-badge {\n//   display: flex;\n//   align-items: center;\n//   justify-content: center;\n//   gap: 4px;\n//   font-size: 12px;\n//   font-weight: 400;\n//   // flex: 1.5;\n//   width: 100%;\n//   // margin-left: 2px;\n// }\n// ion-button {\n//   margin: 5px 0 ;\n//   font-size: 12px;\n// }\n\n// ion-badge ion-text{\n//   // padding: 2px 0 0 0 ;\n// }\n// .top-padding {\n//   padding-top: 10px;\n// }\n\n\nion-searchbar {\n  padding-inline: 5px;\n  color: #92949C;\n  background-color: white;\n  position:fixed;\n  z-index:10\n}\n// ion-select::part(container){\n//   width: 100%;\n// }\n\n// @media (max-width:472px) {\n//   .icon-capacity{\n//     font-size: 10px;\n//   }\n//   ion-badge{\n//       --padding-top:5px;\n//       font-size: 10px;\n//       gap:2px;\n//   }\n//   ion-button{\n//     font-size: 10px;\n//   }\n\n//   .avatar-row{\n//     padding-bottom: 5px;\n//   }\n// }\n\n.spinner-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.15);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-card {\n  &:first-child {\n    margin: 10px 10px 20px;\n  }\n  .wrapper {\n    width: 100%;\n  }\n  margin: 20px 10px;\n  ion-item {\n    --inner-padding-end: 0;\n  }\n  ion-card-header {\n    padding: 5px 10px 0 0px;\n    ion-card-title {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding-inline-start: 10px;\n      justify-content: center;\n      ion-avatar {\n        margin: 0 auto;\n        img {\n          background-size: cover;\n          border-radius: 15px;\n          height: 45px;\n          width: 45px;\n        }\n      }\n      .resource-type-icon {\n        font-size: 40px;\n      }\n      ion-label {\n        font-size: 20px;\n        flex-grow: 3;\n        margin-bottom: 5px;\n\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        .displayName {\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 1;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n        .emailAddress {\n          //   display: block;\n          color: #6e6e6e;\n          font-size: 12px;\n          margin: 2px;\n          font-weight: 500;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 1;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n      .plus-icon {\n        cursor: pointer;\n      }\n    }\n    ion-card-subtitle {\n      font-size: 11px;\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n      .location-icon {\n        margin-right: 2.5px;\n      }\n    }\n  }\n  ion-card-content {\n    display: flex;\n    padding: 5px 0 8px 0;\n    ion-chip {\n      padding-inline: 10px;\n      font-size: 12px;\n      ion-icon {\n        margin-right: 3.5px;\n      }\n      &.dumb {\n        pointer-events: none;\n      }\n    }\n  }\n  ion-item-options {\n    ion-item-option {\n      div {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 5px;\n        font-size: 14px;\n        ion-icon {\n          font-size: 30px;\n        }\n      }\n    }\n  }\n}\n\n.no-places-container {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  align-items: center;\n  text-align: center;\n  padding: 0 20px;\n\n}\n\nion-popover.display-name {\n  --width: 275px;\n  ion-icon {\n    font-size: 16px;\n  }\n  ion-label {\n    margin: 5px 10px;\n    .displayName,\n    .address,\n    .emailAddress {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      margin: 7px 0;\n      word-break: break-word;\n      div {\n        display: flex;\n      }\n    }\n    .address {\n      font-size: 12px !important;\n      // margin-left: -2px;\n      ion-icon {\n        font-size: 16px;\n      }\n    }\n    .displayName {\n      font-size: 15px;\n    }\n    .emailAddress {\n      ion-icon {\n        color: #6e6e6e;\n      }\n      small {\n        color: #6e6e6e;\n        font-size: 12px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
